module.exports = __webpack_public_path__ + "img/Gepuzemeltetesi_mukodtetesi_csomagok_ikon.f09e299e.png";